// The candidate actions the SPA hands to the PARENT frame. `assignToJobInAts` (`shortlist.candidate-actions.service.ng1.ts:303`) — the one candidate action
// the SPA cannot perform itself. The ATS page owns the job, so the frame tells the content script
// which candidate to assign and the host adapter does the rest.
//
// ⚠️ OUTSIDE A FRAME THERE IS NOBODY TO TELL. Upstream posts to `window.parent` unconditionally,
// which from a top-level tab is the tab itself and reaches no one; this sends nothing instead.
import { IFrameEventType, iframeClient, isInIFrame } from '@woo-ext/protocol'

export interface AssignToJobCandidate {
  name?: string | null
  externalId?: string
  atsIdForOpeningCandidate?: string
}

/** `IWooIFrameEventAssignToJobPayload`, verbatim field names. */
export function sendAssignToJob(candidate: AssignToJobCandidate, alertId: number): void {
  if (!isInIFrame()) return
  iframeClient().send(IFrameEventType.AssignToJob, {
    candidateAtsId: candidate.atsIdForOpeningCandidate || candidate.externalId,
    candidateName: candidate.name,
    alertId,
  })
}

/**
 * `openHotlistInAts` (extension-alert-candidates.component.ng1.ts:1652) — "View in Bullhorn" at the
 * end of an ATS export: the parent frame opens the list the export created.
 */
export function sendOpenHotlist(outputParams: unknown): void {
  if (!isInIFrame()) return
  iframeClient().send(IFrameEventType.OpenHotlist, { outputParams })
}
